import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { DataSourceMeta } from './models';
import { SecurityService } from './Security.service';

@Injectable()
export class LoaderService {
    public constructor(
        private http: HttpClient,
        private securityService: SecurityService
    ) {}

    public GetPdf() {
        return this.http
            .get(this.securityService.pdfUri, {
                headers: this._getHeaders(),
                observe: 'response',
                responseType: 'arraybuffer',
            })
            .pipe(
                map((r) => {
                    const type = r.headers.get('Content-Type');
                    const fileName = this._parseFilenameFromContentDisposition(
                        r.headers.get('Content-Disposition')
                    );
                    return new File([r.body], fileName || 'unknown.pdf', { type });
                })
            );
    }

    public GetPdfDataSource() {
        return this.http.get<DataSourceMeta[]>(this.securityService.pdfDataSourceUri, {
            headers: this._getHeaders(),
        });
    }

    public SavePdf(pdf: File) {
        const form = new FormData();
        form.append(pdf.name, pdf);

        return this.http
            .put(this.securityService.pdfUri, form, {
                headers: this._getHeaders().set('Accept', '*/*').delete('content-type'),
            })
            .pipe(
                map((r) => {
                    console.log(r);
                })
            );
    }

    private _parseFilenameFromContentDisposition(contentDisposition: string) {
        if (!contentDisposition) return null;
        const matches = /filename="(.*?)"/g.exec(contentDisposition);

        return matches && matches.length > 1 ? matches[1] : null;
    }

    private _getHeaders() {
        const token = this.securityService.bearerToken;
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
        });
    }
}
